import { render, staticRenderFns } from "./SystemIntro.vue?vue&type=template&id=5d73cf1e&scoped=true&"
import script from "./SystemIntro.vue?vue&type=script&lang=js&"
export * from "./SystemIntro.vue?vue&type=script&lang=js&"
import style0 from "./SystemIntro.vue?vue&type=style&index=0&id=5d73cf1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d73cf1e",
  null
  
)

export default component.exports